import SiteTreeView from "./SiteTreeView";
import { DeviceViewModel, DeviceLinkConnectionViewModel } from "@/TemsManagerWebInterface";
import Localization from "@/Localization";

export default class DeviceLinksControl {

    private siteTreeView: SiteTreeView;  // TODO this shouldn't be required
    private content: JQuery;

    public get Content() { return this.content; }

    constructor(siteTreeView: SiteTreeView, deviceModel: DeviceViewModel) {
        this.siteTreeView = siteTreeView;
        this.content = $("<div>");
        this.updateLinks(deviceModel);
    }

    public updateLinks(deviceModel: DeviceViewModel) {
        if (deviceModel.Links.length > 0) {
            for (var linkElement of deviceModel.Links) {
                // find or create parent element for specific output
                var tabElement = this.content.children(`ul[data-id='${linkElement.OutputName}']`);
                if (tabElement.length === 0) {
                    tabElement =
                        $(`<ul data-id='${linkElement.OutputName}' style='padding-left: 0px;'>
                             <li class='siteTreeElement'>
                               <span class='glyphicon glyphicon-log-out' style='margin-right: 4px;'></span>
                               <span>${linkElement.OutputTitle}</span>
                             </li>
                           </ul>`);

                    this.content.append(tabElement);
                }
                tabElement = tabElement.children("li").first();

                // seperate links into enabled and disabled category
                var enabledLinks: DeviceLinkConnectionViewModel[] = [];
                var disabledLinks: DeviceLinkConnectionViewModel[] = [];
                for (var j = 0, leLen = linkElement.Connections.length; j < leLen; j++) {
                    var link = linkElement.Connections[j];

                    if (link.IsActive) {
                        enabledLinks.push(link);
                    } else {
                        disabledLinks.push(link);
                    }
                }

                // find or create control for adding new links
                var addLinkControl = $(`#add-links-button-${deviceModel.Id}-${linkElement.OutputName}`);
                if (addLinkControl.length === 0) {
                    addLinkControl = $(`<div id='add-links-button-${deviceModel.Id}-${linkElement.OutputName}' class='deviceAddLinkControl'>
                                            <div class='dropdown'>
                                                <p class="dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style="cursor:pointer" role="button">
                                                    <span class="glyphicon glyphicon-plus"></span>
                                                </p>
                                                <ul class="dropdown-menu" id="add-links-dropdown-${deviceModel.Id}-${linkElement.OutputName}">
                                                </ul>
                                            </div>
                                        </div>`);

                    tabElement.append(addLinkControl);
                }

                // compare existing disabledLink-Ids with new ones
                var addLinkDropdown = tabElement.find(`#add-links-dropdown-${deviceModel.Id}-${linkElement.OutputName}`);
                var domIds: string[] = [];
                addLinkDropdown.children("li").each((index, elem) => {
                    domIds.push($(elem).data("id"));
                });
                var modelIds: string[] = disabledLinks.map((dl) => { return dl.Id; });
                var compareLinks = Localization.compareCollections(domIds, modelIds, (id) => { return id; });

                // remove deleted links
                compareLinks.removed.map((id) => {
                    addLinkDropdown.find(`li[data-id='${id}']`).remove();
                });

                // add new links
                compareLinks.added.map((id) => {
                    var disabledLink = disabledLinks.filter((link) => { return link.Id === id; })[0];
                    this.appendLinkToAddDropdown(disabledLink, deviceModel.Id, linkElement.OutputName);
                });

                // find or create parent element for enabled links
                var activeLinks = tabElement.find(`#activeLinks-${deviceModel.Id}-${linkElement.OutputName}`);
                if (activeLinks.length === 0) {
                    activeLinks = $("<ul>", {
                        id: `activeLinks-${deviceModel.Id}-${linkElement.OutputName}`
                    });
                    tabElement.append(activeLinks);
                }

                // compare existing enabledLink-Ids with new ones
                domIds = [];
                activeLinks.children("li").each((index, elem) => {
                    domIds.push($(elem).data("id"));
                });
                modelIds = enabledLinks.map((dl) => { return dl.Id; });
                compareLinks = Localization.compareCollections(domIds, modelIds, (id) => { return id; });

                // remove deleted links
                compareLinks.removed.map((id) => {
                    activeLinks.find(`li[data-id='${id}']`).remove();
                });

                //add new links
                compareLinks.added.map((id) => {
                    var enabledLink = enabledLinks.filter((link) => { return link.Id === id; })[0];
                    this.appendLinkToEnabledList(enabledLink, deviceModel.Id, linkElement.OutputName);
                });

                this.determineAddLinkControlState(addLinkControl);
            }
        } else {
            this.content.html("");
        }

    }

    public determineAddLinkControlState(addLinkControl) {
        if (addLinkControl.find(".dropdown-menu > li").length === 0) {
            addLinkControl.hide();
        } else {
            addLinkControl.show();
        }
    }

    public appendLinkToEnabledList(enabledLink: DeviceLinkConnectionViewModel, deviceId: string, outputName: string) {
        var activeLinks = $(`#activeLinks-${deviceId}-${outputName}`);

        var linkControls = $("<span>")
            .append($("<span>").addClass("glyphicon glyphicon-trash editControl alignTreeElementRight"))
            .click(() => this.siteTreeView.disableLink(deviceId, outputName, enabledLink.Id));

        activeLinks.append($("<li>", { 'data-id': enabledLink.Id })
            .append($("<span>", { "class": "glyphicon glyphicon-log-in", "style": "margin-right: 4px;" }))
            .append($("<span>", { html: enabledLink.InputTitle }))
            .append($("<span>", { html: ` of ${enabledLink.TargetName} ` }))
            .append(linkControls));

        var addLinkControl = $(`#add-links-button-${deviceId}-${outputName}`);
        this.determineAddLinkControlState(addLinkControl);
    }

    public appendLinkToAddDropdown(disabledLink: DeviceLinkConnectionViewModel, deviceId: string, outputName: string) {
        var addLinkDropdown = $(`#add-links-dropdown-${deviceId}-${outputName}`);
        addLinkDropdown.append(
            $("<li>", {
                'data-id': disabledLink.Id,
                'data-target': disabledLink.TargetName,
                'data-input': disabledLink.InputName
            }).append(
                $("<a>", {
                    href: "#",
                    html: `${disabledLink.InputTitle} of ${disabledLink.TargetName}`,
                }).click(() => this.siteTreeView.enableLink(deviceId, outputName, disabledLink.Id))
                )
        );

        var addLinkControl = $(`#add-links-button-${deviceId}-${outputName}`);
        this.determineAddLinkControlState(addLinkControl);
    }
}
